import React from 'react'
import { useTranslate } from 'react-polyglot'

import { Button, Avatar, Text, Label, Icon } from 'components'

import './memberList.scss'

export default ({ articleCreator, responsibleMembers, onDelete }) => {
	const t = useTranslate()

	return (
		<div className="c-member-list">
			{(!responsibleMembers || responsibleMembers.length === 0) && (
				<div className="c-member-list__item">
					<div className="c-member-list__name">
						<Avatar
							initials="EL"
							image="assets/img/mr-svensson.png"
							imageSrc="local"
						/>
						<div>
							<Text color="dark">
								<small>Mr. Svensson</small>
							</Text>
						</div>
					</div>
					<div className="c-member-list__actions">
						<Label text={t('creator')} />
					</div>
				</div>
			)}
			{responsibleMembers &&
				responsibleMembers.map(m => {
					const initials =
						m && m.firstName && m.lastName
							? m.firstName.charAt(0) + m.lastName.charAt(0)
							: 'n/a'

					return (
						<div className="c-member-list__item" key={m.id}>
							<div className="c-member-list__name">
								<Avatar initials={initials} image={m.image} />
								<div>
									<Text color="dark">
										<small>
											{m.firstName} {m.lastName}
										</small>
									</Text>
								</div>
							</div>
							<div className="c-member-list__actions">
								{articleCreator === m.id && (
									<Label text={t('creator')} />
								)}
								{responsibleMembers.length > 1 && (
									<div>
										<Button
											icon={<Icon name="delete" />}
											fullWidth
											size="small"
											onClick={() => {
												onDelete(m.id)
											}}
										/>
									</div>
								)}
							</div>
						</div>
					)
				})}
		</div>
	)
}
